import React, { ReactNode } from "react";

import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./VideoDescription.module.scss";

interface Props {
  children: ReactNode[];
  title?: ReactNode;
}

const VideoDescription: React.FC<Props> = ({ children, title }) => {
  return (
    <div className={styles.container}>
      {title && <p className={styles.title}>{title}</p>}
      {React.Children.map(children, (child) => (
        <div className={styles.bulletPoint}>
          <FontAwesomeIcon className={styles.icon} icon={faCheckCircle} /> {child}
        </div>
      ))}
    </div>
  );
};

export default VideoDescription;
